// Overview: greeting, the grid codes in force per region and, for operators, recent activity; the region layout provides the jurisdiction.
import { createFileRoute } from "@tanstack/react-router";

import { OverviewPage } from "@/features/overview/OverviewPage";

export const Route = createFileRoute("/_app/$region/")({
  staticData: { crumb: "Overview" },
  component: OverviewPage,
});
